import styled from "styled-components";

export const Section = styled.section`
  margin-bottom: 1rem;
`;

export const Block = styled.div<{ $enabled: boolean }>`
  border: 1px solid #ced4da;
  border-radius: 4px;
  margin: 0.6rem 0;
  padding: 0.6rem 0.8rem;
  background: ${props => (props.$enabled ? "#fff" : "#fafafa")};
`;

export const Toggle = styled.div`
  display: inline-flex;
  align-items: center;

  .custom-control-label {
    cursor: pointer;
  }

  /* Centre the track and the knob on the label text whatever the theme sizes are.
     "translate" is separate from "transform", which Bootstrap uses to slide the knob. */
  .custom-control-label::before,
  .custom-control-label::after {
    top: 50%;
    translate: 0 -50%;
  }
`;

export const ErrorText = styled.div`
  color: #b00020;
  font-size: 0.8rem;
  margin-top: 0.2rem;
`;

export const WarningText = styled.div`
  grid-column: 2 / -1;
  color: #8a5a00;
  font-size: 0.8rem;
  margin-top: 0.15rem;
`;

export const HelpText = styled.small`
  display: block;
  color: #656565;
  margin-top: 0.2rem;
`;

export const FirstFreeText = styled.p`
  background: #fff;
  border: 1px solid #ff6136;
  padding: 0.4rem 0.6rem;
  margin: 0.8rem 0 0.4rem 0;
  font-size: 12px;
`;

const LINE_COLUMNS = "2rem minmax(0, 2fr) minmax(0, 2fr) minmax(0, 1fr)";

export const LineList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  background: #fff;
`;

export const Line = styled.li`
  display: grid;
  grid-template-columns: ${LINE_COLUMNS};
  align-items: center;
  column-gap: 0.5rem;
  padding: 0.35rem 0.5rem;
  border-bottom: 1px solid #ced4da;
`;

export const LineHeader = styled.div`
  display: grid;
  grid-template-columns: ${LINE_COLUMNS};
  column-gap: 0.5rem;
  padding: 0.35rem 0.5rem;
  border-bottom: 1px solid #ced4da;
  background: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  color: #656565;
`;

export const InactiveName = styled.span`
  color: #999;
`;

/* Capped so the native option list on Windows (as wide as the select) never overflows the screen. */
export const LimitSelectControl = styled.select`
  max-width: 12rem;
`;
